import React from 'react';
import Container from 'react-bootstrap/Container';
import "./index.css";

export default function Banner() {
    const imgCDNURL = process.env.REACT_APP_CDN + "eaimortgage/images/";
    return (
        <div className="banner">
            <Container>
                <h1 className="banner-heading">
                    Unlock Your
                    <br />
                    Homeownership
                    <br />
                    Dream with Ai
                </h1>
            </Container>
        </div>
    )
}
